import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/admin/AdminLayout";

import Dashboard from "@/pages/Dashboard";
import Profil from "@/pages/Profil";
import Guru from "@/pages/Guru";
import VisiMisi from "@/pages/VisiMisi";
import Berita from "@/pages/Berita";
import BeritaDetail from "@/pages/BeritaDetail";
import Kegiatan from "@/pages/Kegiatan";
import KegiatanDetail from "@/pages/KegiatanDetail";
import Galeri from "@/pages/Galeri";
import Kontak from "@/pages/Kontak";
import Login from "@/pages/Login";

import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBerita from "@/pages/admin/AdminBerita";
import AdminKegiatan from "@/pages/admin/AdminKegiatan";
import AdminGuru from "@/pages/admin/AdminGuru";
import AdminGaleri from "@/pages/admin/AdminGaleri";
import AdminPendaftaran from "@/pages/admin/AdminPendaftaran";
import AdminKontak from "@/pages/admin/AdminKontak";
import AdminProfil from "@/pages/admin/AdminProfil";
import AdminVisiMisi from "@/pages/admin/AdminVisiMisi";
import AdminPengaturan from "@/pages/admin/AdminPengaturan";
import AdminBackup from "@/pages/admin/AdminBackup";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="profil" element={<Profil />} />
                <Route path="guru" element={<Guru />} />
                <Route path="visi-misi" element={<VisiMisi />} />
                <Route path="berita" element={<Berita />} />
                <Route path="berita/:slug" element={<BeritaDetail />} />
                <Route path="kegiatan" element={<Kegiatan />} />
                <Route path="kegiatan/:slug" element={<KegiatanDetail />} />
                <Route path="galeri" element={<Galeri />} />
                <Route path="kontak" element={<Kontak />} />
              </Route>

              <Route path="/login" element={<Login />} />

              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<AdminDashboard />} />
                <Route path="profil" element={<AdminProfil />} />
                <Route path="guru" element={<AdminGuru />} />
                <Route path="visi-misi" element={<AdminVisiMisi />} />
                <Route path="berita" element={<AdminBerita />} />
                <Route path="kegiatan" element={<AdminKegiatan />} />
                <Route path="galeri" element={<AdminGaleri />} />
                <Route path="kontak" element={<AdminKontak />} />
                <Route path="pendaftaran" element={<AdminPendaftaran />} />
                <Route path="pengaturan" element={<AdminPengaturan />} />
                <Route path="backup" element={<AdminBackup />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="bottom-right" richColors />
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
